import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';

// Helper to load a Webpack require.context into a namespace resource map
function loadContext(context: any): Record<string, any> {
  const res: Record<string, any> = {};
  context.keys().forEach((key: string) => {
    const match = key.match(/^\.\/(.+)\.json$/);
    if (match) {
      const lang = match[1];
      res[lang] = context(key);
    }
  });
  return res;
}

// Load contexts for each namespace via require.context (must be literal for Webpack)
let classExploreContext: any;
try { classExploreContext = (require as any).context('./locales/class/explore', false, /\.json$/); } catch { classExploreContext = { keys: () => [] as string[] }; }
let titleWelcomeContext: any;
try { titleWelcomeContext = (require as any).context('./locales/title/welcome', false, /\.json$/); } catch { titleWelcomeContext = { keys: () => [] as string[] }; }
let actorAccountContext: any;
try { actorAccountContext = (require as any).context('./locales/actor/account', false, /\.json$/); } catch { actorAccountContext = { keys: () => [] as string[] }; }
let actorLibraryContext: any;
try { actorLibraryContext = (require as any).context('./locales/actor/library', false, /\.json$/); } catch { actorLibraryContext = { keys: () => [] as string[] }; }
let videoContextContext: any;
try { videoContextContext = (require as any).context('./locales/video/context', false, /\.json$/); } catch { videoContextContext = { keys: () => [] as string[] }; }
let titleToolbarContext: any;
try { titleToolbarContext = (require as any).context('./locales/title/toolbar', false, /\.json$/); } catch { titleToolbarContext = { keys: () => [] as string[] }; }
// Promo subject namespace for dynamic meta title/description/OG strings
let promoSubjectContext: any;
try { promoSubjectContext = (require as any).context('./locales/promo/subject', false, /\.json$/); } catch { promoSubjectContext = { keys: () => [] as string[] }; }

// Build resources object for i18next
const resources: Record<string, any> = {};
const contexts: Record<string, any> = {
  classExplore: classExploreContext,
  titleWelcome: titleWelcomeContext,
  actorAccount: actorAccountContext,
  actorLibrary: actorLibraryContext,
  videoContext: videoContextContext,
  titleToolbar: titleToolbarContext,
  promoSubject: promoSubjectContext,
};
Object.entries(contexts).forEach(([ns, ctx]) => {
  const nsResources = loadContext(ctx);
  Object.entries(nsResources).forEach(([lang, data]) => {
    if (!resources[lang]) resources[lang] = {};
    resources[lang][ns] = data;
  });
});

i18n
  .use(LanguageDetector)
  .use(ICU)
  .use(initReactI18next)
  .init(
    {
      resources,
      fallbackLng: 'en',
      // Detect language via hl query parameter when present for anonymous users
      detection: {
        lookupQuerystring: 'hl',
      },
      ns: Object.keys(contexts),
      defaultNS: 'catalog',
      // Fallback search across all namespaces for missing keys
      fallbackNS: Object.keys(contexts),
      interpolation: { escapeValue: false },
    },
    () => {
      // After initialization, remove hl parameter to avoid re-applying on navigation
      if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search);
        if (params.has('hl')) {
          params.delete('hl');
          const newQuery = params.toString();
          const newUrl = window.location.pathname +
            (newQuery ? `?${newQuery}` : '') +
            window.location.hash;
          window.history.replaceState({}, '', newUrl);
        }
      }
    }
  );

export default i18n;